// extracted by mini-css-extract-plugin
export default {"text":"NotFound_text__0q9lj","heavyText":"NotFound_heavyText__DNUQe","detail":"NotFound_detail__BAQYq"};